/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/prefer-default-export */
import React from "react";

type ILoaderSpinner = {
  color?: string;
  width?: string;
  height?: string;
};

export const Spinner = (props: ILoaderSpinner | undefined) => {
  if (!props) return <></>;

  const { color, width, height } = props;

  return (
    <div className="loader-spinner" style={{ color, width, height }}>
      <div
        style={{
          borderColor: `${color} transparent transparent transparent`,
          width,
          height,
        }}
      />
      <div
        style={{
          borderColor: `${color} transparent transparent transparent`,
          width,
          height,
        }}
      />
      <div
        style={{
          borderColor: `${color} transparent transparent transparent`,
          width,
          height,
        }}
      />
      <div
        style={{
          borderColor: `${color} transparent transparent transparent`,
          width,
          height,
        }}
      />
    </div>
  );
};

Spinner.defaultProps = {
  color: "#1D1D1B",
  width: "48px",
  height: "48px",
};
